import { atom } from 'jotai'

export { adminOfficialsRemoteAtom as adminOfficialsAtom } from './remoteAtoms'
export const adminOfficialFilterAtom = atom('')
